import { api } from "..";
import { ContentGroup } from "@/types/contentgroup";

export const contentGroupApi = api.injectEndpoints({
  endpoints: (build) => ({
    
    getContentGroupList:build.query<ContentGroup[],{user_id:string,group_name:string}>({
      query:({user_id,group_name})=>`/contents/group?user_id=${user_id}&group_name=${group_name}`,
      providesTags: ['ContentGroup'],
    }),

    createContentGroup:build.mutation<ContentGroup,Omit<ContentGroup, 'id'|'content_nums'|'create_at'|'update_at'|'delete_at'>>({
        query:(contentGroup)=>(
          {
            url: `contents/group`,
            method: 'POST',
            body: contentGroup,
          }
        ),
        transformErrorResponse: (baseQueryReturnValue, meta, arg) =>baseQueryReturnValue.data,
        invalidatesTags: ['ContentGroup'],
    })
  }),
});

export const {useCreateContentGroupMutation,useGetContentGroupListQuery} = contentGroupApi